import React from "react";
import CommonFilterStructure from "../../common-components/CommonFilterStructure";

const KeywordFilterStructures = ({
  decryptedText,
  filterValues,
  setFilterValues,
  onClickSearch,
  searchFilterApplied = false,
}) => {
  return (
    <CommonFilterStructure
      from={"automation-keywords"}
      decryptedText={decryptedText}
      setFilters={setFilterValues}
      filters={filterValues}
      searchFilterApplied={searchFilterApplied}
      onClickSearch={onClickSearch}
    />
  );
};

export default KeywordFilterStructures;
